import {
  AuditLogResource,
  ListAuditLogsFilterParameterResourceTypeEq
} from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";

/**
 * v1's single `PayerPayeeEngagement` audit resource is two resources on v3, one
 * per side of the relationship. This is the payer's view of a contractor, so the
 * id is a `payeeEngagementId` and the trail lives under `PayeeEngagement`.
 */
export function usePayeeEngagementHistoryResources(
  payeeEngagementId: string
): AuditLogResource[] {
  return useMemo(
    () => [
      {
        resourceType:
          ListAuditLogsFilterParameterResourceTypeEq.PAYEE_ENGAGEMENT,
        resourceId: payeeEngagementId
      }
    ],
    [payeeEngagementId]
  );
}
